export default __webpack_public_path__ + "static/media/logo.97e4c1ec.svg";